module.exports = __webpack_public_path__ + "media/images/athletes/2500-50d63e56372f45e191e0d72d7a096c5b.png";